import api from './api';

const chatService = {
  /**
   * Get list of conversations
   */
  getConversations: async (page = 1, limit = 20) => {
    const response = await api.get('/api/chat/conversations', {
      params: { page, limit }
    });
    return response.data;
  },

  /**
   * Get chat history for a specific customer
   */
  getChatHistory: async (phone, page = 1, limit = 50) => {
    const response = await api.get(`/api/chat/history/${phone}`, {
      params: { page, limit }
    });
    return response.data;
  },

  /**
   * Send message to customer
   */
  sendMessage: async (phone, message) => {
    const response = await api.post('/api/chat/send', {
      phone,
      message
    });
    return response.data;
  },

  /**
   * Search customers
   */
  searchCustomers: async (query) => {
    const response = await api.get('/api/chat/search', {
      params: { query }
    });
    return response.data;
  },

  /**
   * Get all customers (for new-chat picker)
   */
  getAllCustomers: async (search = '', page = 1, limit = 50) => {
    const response = await api.get('/api/customers', {
      params: { search, page, limit }
    });
    return response.data;
  }
};

export default chatService;
